export default __webpack_public_path__ + "static/gb-nir-8ad03581959bce8c3da0e389104cf1e3.svg";